export default __webpack_public_path__ + "static/Entenda0140-5ad4cd53191863352014f11c7a88bafe.jpg";